// src/components/Title.jsx
import React from 'react';
import {Typography} from '@mui/material';

export const Title = ({
    variant = 'h4',
    color = '#0d457c',
    align = 'left',
    sx = {},
    children,
    ...rest
}) => {
    return (
        <Typography
            variant={variant}
            align={align}
            sx={{
                fontWeight: 'bold',
                mb: 3,
                color,
                textShadow: '1px 1px 3px rgba(0,0,0,0.2)', // ligeiro sombreamento
                ...sx,
            }}
            {...rest}
        >
            {children}
        </Typography>
    );
};
